import { Button, Image } from '@heroui/react';
import { useCategories } from '../../../entites/categories';
import { useEffect, useState } from 'react';
import { useSubcategories } from '../../../entites/subcategories';
import { ICategory } from '@shared/types.ts';
import { useNavigate } from 'react-router-dom';

export const NavbarCategories = ({ isShow = false }: { isShow?: boolean }) => {
  const { rawData } = useCategories();
  const [selectedCategory, setSelectedCategory] = useState<
    ICategory | undefined
  >();
  const { rawData: subcategories } = useSubcategories({
    categoryId: selectedCategory?.id,
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (rawData && rawData.length > 0 && !selectedCategory) {
      setSelectedCategory(rawData[0]);
    }
  }, [rawData]);

  if (!isShow) return null;

  const list = subcategories && subcategories[0].children ? subcategories[0].children : [];

  return (
    <div className="sticky z-40 h-[580px] flex flex-col w-screen top-[92px] bg-white">
      <div className="container max-w-7xl h-full mx-auto flex flex-row gap-x-9 pt-9">
        <div className="w-72 gap-y-2 flex flex-col">
          {rawData &&
            rawData.map((category, index) => (
              <Button
                key={index}
                color="primary"
                variant={
                  selectedCategory?.id === category.id ? 'flat' : 'light'
                }
                fullWidth
                className="text-[#222222] justify-start text-base font-semibold"
                onPress={() => {
                  if (selectedCategory?.id === category.id) {
                    const params = new URLSearchParams({
                      ct: selectedCategory.name,
                    });
                    navigate(
                      `/category/${selectedCategory.id}?${params.toString()}`
                    );
                  } else {
                    setSelectedCategory(category);
                  }
                }}
              >
                { category.icon && <Image width={24} height={24} radius='none' src={category.icon || ''} alt={category.name} /> }
                {category.name}
              </Button>
            ))}
        </div>
        <div className="flex-grow grid grid-cols-3 gap-x-9 gap-y-2">
          {list.map((subcategory, index) => (
              <Button
                key={index}
                variant="light"
                fullWidth
                className="text-[#222222] justify-start text-base"
                onPress={() => {
                  const params = new URLSearchParams({
                    ct: selectedCategory?.name || '',
                    st: subcategory.name || '',
                  }).toString();
                  navigate(
                    `/category/${selectedCategory?.id}/${subcategory.id}?${params}`
                  );
                }}
              >
                {subcategory.name}
              </Button>
            ))}
        </div>
      </div>
    </div>
  );
};
